import { forwardRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { alpha, Avatar, Tooltip } from '@mui/material';
import { OutreachTypeAvatarProps } from './types';
import {
  getColorByOutreachType,
  getIconByOutreachType,
  getLabelByOutreachType,
} from 'src/components/outreach-type-avatar/utils';

// ----------------------------------------------------------------------

const OutreachTypeAvatar = forwardRef<HTMLDivElement, OutreachTypeAvatarProps>(
  ({ hideTooltip = false, outreachType, size, sx, ...other }, ref) => {
    const theme = useTheme();

    const color = getColorByOutreachType(outreachType, theme);

    return (
      <Tooltip title={hideTooltip ? '' : getLabelByOutreachType(outreachType)}>
        <Avatar
          ref={ref}
          variant="rounded"
          sx={{
            height: size,
            width: size,
            color: alpha(color, 0.8),
            backgroundColor: alpha(color, 0.1),
            border: 1,
            borderColor: alpha(color, 0.3),
            fontWeight: theme.typography.fontWeightMedium,
            ...sx,
          }}
          {...other}
        >
          {getIconByOutreachType(outreachType, size * 0.5)}
        </Avatar>
      </Tooltip>
    );
  }
);

export default OutreachTypeAvatar;
